export const IconFieldDT = {
	iconfield: {
		extend: {
			fullWidth: '100%',
		},
		css: ({ dt }) => `
          .p-iconfield__full-width {
              width: ${dt('iconfield.full.width')};
          }
        `,
	},
};
